import { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

import { FrameworkProvider } from './context/up-api-provider/framework-context';

const CollaboratorsPage = lazy(
  () => import('./pages/collaborators/collaborators.page'),
);
export const CollaboratorsRoutes = () => {
  return (
    <FrameworkProvider>
      <Routes>
        <Route>
          <Route index element={<CollaboratorsPage />} />
        </Route>
      </Routes>
    </FrameworkProvider>
  );
};
